import { useEffect, useMemo, useState } from "react";

import type { AutoCompleteSelectItem } from "../types";

export function useAutoComplete<T>(
  items: T[] | undefined | null,
  value: string | number | null | undefined,
  getLabel: (item: T) => string,
  getValue: (item: T) => string | number | null | undefined,
  getId: (item: T) => string,
) {
  const [query, setQuery] = useState("");
  const suggestions: AutoCompleteSelectItem[] = useMemo(() => {
    if (!items) return [];
    return items
      .filter((item) =>
        getLabel(item).toLowerCase().includes(query.toLowerCase()),
      )
      .map((item) => ({
        id: getId(item),
        value: getValue(item),
        label: getLabel(item),
      }));
  }, [items, query, getLabel, getValue, getId]);

  useEffect(() => {
    if (items && value !== undefined && value !== null) {
      const found = items.find((item) => getValue(item) === value);
      if (found) setQuery(getLabel(found));
    } else if (value === undefined || value === null) {
      setQuery("");
    }
  }, [items, value, getLabel, getValue]);

  return { query, setQuery, suggestions };
}
